"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeSrt = void 0;
const formatSingleSrtTimestamp = (timestamp) => {
    const hours = Math.floor(timestamp / 3600000);
    const minutes = Math.floor((timestamp % 3600000) / 60000);
    const seconds = Math.floor((timestamp % 60000) / 1000);
    const milliseconds = Math.floor(timestamp % 1000);
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')},${String(milliseconds).padStart(3, '0')}`;
};
const formatSrtTimestamp = (startMs, endMs) => {
    return `${formatSingleSrtTimestamp(startMs)} --> ${formatSingleSrtTimestamp(endMs)}`;
};
const serializeSrt = ({ lines }) => {
    let currentIndex = 0;
    return lines
        .map((s) => {
        currentIndex++;
        if (s.length === 0) {
            return null;
        }
        const firstTimestamp = s[0].startMs;
        const lastTimestamp = s[s.length - 1].endMs;
        return [
            // Index
            currentIndex,
            formatSrtTimestamp(firstTimestamp, lastTimestamp),
            // Text
            s.map((caption) => caption.text).join(''),
        ].join('\n');
    })
        .filter(Boolean)
        .join('\n\n');
};
exports.serializeSrt = serializeSrt;
